/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 書類種別。未指定は汎用の各種書類。
childMedicalCertificate: 子ども医療証（マル子）。汎用の各種書類とは別管理。
 */
export type PutPatientAdditionalDocumentsBodiesType = typeof PutPatientAdditionalDocumentsBodiesType[keyof typeof PutPatientAdditionalDocumentsBodiesType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PutPatientAdditionalDocumentsBodiesType = {
  childMedicalCertificate: 'childMedicalCertificate',
} as const;
